import axios from '@/axios';

export async function getOrgons(params) {
    try {
        const { data } = await axios.get("/orgon/list", { params });
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function getTypeOrgons() {
    try {
        const { data } = await axios.get("/type_orgons");
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function getTransplanterUnities() {
    try {
        const { data } = await axios.get("/unities/list_transplanter", { params: { flg: '1' } });
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function saveOrgon(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/orgon/${id}` : `/orgon`;
    return await axios({ method, url, data: data });
}
